import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { OrderItemTrackingStatusEnum } from '@models';
import { ApiService } from './api-service';

export const AVAILABLE_STATUSES_FOR_CHANGE = [
  OrderItemTrackingStatusEnum.Ordered,
  OrderItemTrackingStatusEnum.Shipped,
  OrderItemTrackingStatusEnum.Delivered,
  OrderItemTrackingStatusEnum.Canceled,
  OrderItemTrackingStatusEnum.ReturnStarted,
  OrderItemTrackingStatusEnum.ReturnReceived,
] as const;

export type AvailableStatusForChange = (typeof AVAILABLE_STATUSES_FOR_CHANGE)[number];

export const CHANGE_STATUS_LABELS: Record<AvailableStatusForChange, string> = {
  [OrderItemTrackingStatusEnum.Ordered]: 'Order',
  [OrderItemTrackingStatusEnum.Shipped]: 'Ship',
  [OrderItemTrackingStatusEnum.Delivered]: 'Deliver',
  [OrderItemTrackingStatusEnum.Canceled]: 'Cancel',
  [OrderItemTrackingStatusEnum.ReturnStarted]: 'Start Return',
  [OrderItemTrackingStatusEnum.ReturnReceived]: 'Receive Return',
};
export type ShippingBody = {
  expectedDeliveryAt: string;
  trackingNumber: string;
  carrier: string;
};

export type ChangeStatusBody = ShippingBody | Object;

const URL_BY_STATUS: Record<AvailableStatusForChange, string> = {
  [OrderItemTrackingStatusEnum.Ordered]: 'order',
  [OrderItemTrackingStatusEnum.Delivered]: 'deliver',
  [OrderItemTrackingStatusEnum.Shipped]: 'ship',
  [OrderItemTrackingStatusEnum.Canceled]: 'cancel',
  [OrderItemTrackingStatusEnum.ReturnStarted]: 'start-return',
  [OrderItemTrackingStatusEnum.ReturnReceived]: 'receive-return',
};

@Injectable({
  providedIn: 'root',
})
export class RefundService {
  private readonly apiService = inject(ApiService);

  changeStatus(id: string, status: AvailableStatusForChange, body: ChangeStatusBody = {}): Observable<unknown> {
    const statusUrl = URL_BY_STATUS[status];
    if (statusUrl) {
      return this.apiService.post(`line-items/${id}/${statusUrl}`, body);
    }
    return of(new Error('Not available status'));
  }
}
